import { HttpService } from "@/core";
import { StoreMaterialPageReq, StoreMaterialPageResp } from "./store-material-interface";

export class StoreMaterialService {
  static usePageApi() {
    const api = (params: StoreMaterialPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/storage/material/list",
        params,
      });
    return HttpService.usePagination<StoreMaterialPageResp>(api);
  }
}
